<template>
  <el-container>
    <el-aside width="230px">
        <el-menu
          :default-openeds="['']"
          :default-active="defaultActive"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          text-color="#fff"
          :unique-opened="uniqueOpened"
          active-text-color="#ffd04b">
          <div  v-for="(item,index) in routes" v-bind:key="index">
            <el-submenu :index="index.toString()" v-if="item.name == ''">
              <template slot="title" >
                <i :class="item.meta.icon"></i>
                <span>{{item.meta.title}}</span>
              </template>
              
              <el-menu-item-group v-if="item.children != 0"   v-for="(item1,index1) in item.children" v-bind:key="index1">
                <router-link :to="item1.path">
                  <el-menu-item :index="index.toString()+ '-' + index1.toString()" @click="to_nav(item1.path,index.toString()+ '-' + index1.toString())">{{item1.meta.title}}</el-menu-item>
                </router-link>
                
              </el-menu-item-group>
            </el-submenu>
            <router-link :to="item.path">
                <el-menu-item :index="index.toString()" @click="to_nav(item.path,index.toString())" v-if="item.name != '' && item.name != '404'">
                <i :class="item.meta.icon"></i>
                <span slot="title">{{item.meta.title}}</span> 
              </el-menu-item>
            </router-link>
           
          </div>
        </el-menu>
    </el-aside>
  </el-container>
</template>

<script>
export default {
  name: 'navLeft',
  data () {
    return {
      uniqueOpened: true,
      routes: this.$store.getters.routerList,
      defaultActive: ''
    }
  },
  
  created(){
    // console.log(this.$store.getters.routerList)
      var str = window.location.href.split("/") 
      var targetStr = str[str.length-1];
      if(targetStr != 'index'){
        this.defaultActive = localStorage.getItem("defaultActive");
      }
  },
  methods: {
      handleOpen(key, keyPath) {
      },
      handleClose(key, keyPath) {
        // console.log(key)
      },
      to_nav(path,index){
        localStorage.setItem("defaultActive", index);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-menu{
    border: none;
  }
  .el-container{
    width: 230px;
    height: 100%;
    background-color: #545c64;
    float: left;
    overflow-x: hidden;
  }

  .el-container /deep/ .el-aside::-webkit-scrollbar {
    width: 8px; /*滚动条宽度*/
    height: 10px; /*滚动条高度*/
  }
  .el-container  /deep/ .el-aside::-webkit-scrollbar-track {
    border-radius: 10px; /*滚动条的背景区域的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(238,238,238, 0.3);
    background-color: #eeeeee; /*滚动条的背景颜色*/
  }
  .el-container /deep/ .el-aside::-webkit-scrollbar-thumb {
    border-radius: 10px; /*滚动条的圆角*/
    -webkit-box-shadow: inset 0 0 6px rgba(145, 143, 0143, 0.3);
    background-color: rgb(145, 143, 143); /*滚动条的背景颜色*/
  }
  
</style>



// WEBPACK FOOTER //
// src/components/navLeft.vue